import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import ListSubheader from "@material-ui/core/ListSubheader";
import IconButton from "@material-ui/core/IconButton";
import ViewCompactOutlinedIcon from "@material-ui/icons/ViewCompactOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import AddIcon from "@material-ui/icons/Add";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import ReplayIcon from "@material-ui/icons/Replay";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";
import SlideshowIcon from "@material-ui/icons/Slideshow";
import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DoneIcon from "@material-ui/icons/Done";
import { Badge, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormGroup, Popover, Slide, Tooltip, Typography } from "@material-ui/core";
import { Col, Input, Label, Row } from "reactstrap";
import { HeaderPopover } from "./HeaderPopover";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import JirangoSwitch from "../../../components/JirangoSwitch/JirangoSwitch";
import MobileFriendlyIcon from "@material-ui/icons/MobileFriendly";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: "transparent",
  },
  gridList: {
    height: "calc(100%)",
    width: "100%",
    padding: 20,
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
    "&:hover": {
      color: "#fff",
    },
  },
}));

export default function LayoutGrid(props) {
  const {
    layouts = [],
    createLayout = () => null,
    deleteLayout = () => null,
    deletedLayouts = [],
    selectedLayout = null,
    onEdit = () => null,
    show = false,
    toggleGrid = () => null,
    selectLayout = () => null,
    eventName,
    events,
    eventId,
    activeLayout,
  } = props;
  const classes = useStyles();
  const [createDialog, toggleCreateDialog] = React.useState(false);
  const [confirmDialog, toggleConfirmDialog] = React.useState(false);
  const [copyNo, setCopyNo] = React.useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popOpen, setPopOpen] = React.useState({});
  const [editableLayout, setEditableLayout] = React.useState(null);
  const handlePopoverOpen = (id) => {
    setPopOpen({ [id]: true });
  };
  const handlePopoverClose = (id) => {
    setPopOpen({ [id]: false });
  };
  const open = Boolean(anchorEl);
  return (
    <div style={{ height: show ? "100vh" : undefined }}>
      <Slide direction="up" in={show} unmountOnExit>
        <div className={classes.root}>
          <GridListTile
            key="Subheader"
            className="s-header"
            cols={2}
            style={{
              textAlign: "left",
              width: "100%",
              paddingLeft: 6,
            }}
          >
            <ListSubheader className="primary-text" style={{ fontSize: 18 }} component="div">
              <SystemLabel name="MyLayouts" />
            </ListSubheader>
          </GridListTile>
          <GridList
            className="layout-list"
            style={{
              maxHeight: "calc(100vh - 64px)",
              overflowY: "auto",
              padding: 20,
              paddingRight: 0,
              width: "100%",
            }}
            cellHeight={50}
          >
            <div className="create-layout-placeholder" onClick={() => toggleCreateDialog(true)}>
              <div className="centered-text">
                <AddIcon className=" placeholder-icon" />
                <div className="grid-label">
                  <SystemLabel name="CreateLayout" />
                </div>
              </div>
            </div>
            {layouts
              .filter((l) => l.eventId == eventId)
              .map((l, i) => {
                let isDeleted = deletedLayouts.find((dl) => dl.meetingLayoutId == l.meetingLayoutId);
                let event = events.find((e) => e.eventId == l.eventId);
                return (
                  <GridListTile
                    className="layout-card-item"
                    onClick={() => selectLayout(l.meetingLayoutId, l.name)}
                    key={i}
                    style={{
                      width: "calc(25% - 10px)",
                      height: 250,
                      flexBasis: " calc(25% - 10px)",
                      margin: "10px 0px",
                      cursor: "pointer",
                      marginRight: 10,
                    }}
                  >
                    <div className="card-item-wrapper">
                      {activeLayout && activeLayout.meetingLayoutId == l.meetingLayoutId ? cardItemText("Active") : null}

                      {isDeleted ? cardItemText("Deleted") : null}

                      {l.eventId != eventId && event ? (
                        <div className={`card-item-text added`}>
                          {event.name}
                          {l.eventId}
                        </div>
                      ) : null}
                    </div>
                    <div className="preview-icon">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          selectLayout(l.meetingLayoutId, l.name);
                          toggleGrid();
                        }}
                        aria-label={`delete layout ${l.name}`}
                        className={classes.icon}
                      >
                        <Tooltip title={<SystemLabel name="StarEditLayout" />}>
                          <BuildOutlinedIcon />
                        </Tooltip>
                      </IconButton>
                      <HeaderPopover tooltipText={"LayoutActions"} icon={<MoreVertOutlinedIcon className="secondary-text" />}>
                        <div
                          className="pop-list"
                          style={{
                            minWidth: 300,
                            maxWidth: 310,
                            background: "rgb(70 71 83)",
                          }}
                        >
                          <Row>
                            <Col>
                              <div
                                className={"list-option"}
                                onClick={(e) => {
                                  /*        e.stopPropagation(); */
                                  setEditableLayout(l);
                                }}
                              >
                                <Row>
                                  <Col style={{ display: "flex" }}>
                                    <EditOutlinedIcon className="pop-list-icon" />
                                    <SystemLabel name="Edit" />
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                          <hr className="thin-hr-light" />
                          <Row>
                            <Col>
                              <div className={"list-option"} style={{ display: "flex" }}>
                                <MobileFriendlyIcon className="pop-list-icon" />
                                <SystemLabel name="MobileLayout" />
                                <JirangoSwitch
                                  onChange={() => {
                                    const modifiedLayout = l;
                                    modifiedLayout.mobile = !l.mobile;
                                    onEdit(modifiedLayout);
                                  }}
                                  isChecked={l.mobile}
                                />
                              </div>
                            </Col>
                          </Row>
                          <hr className="thin-hr-light" />
                          <Row>
                            <Col>
                              <div
                                className={"list-option"}
                                onClick={(e) => {
                                  /*  e.stopPropagation(); */
                                  let copyCount = copyNo[l.meetingLayoutId] || 1;
                                  setCopyNo({
                                    ...copyNo,
                                    [l.meetingLayoutId]: 1,
                                  });
                                  createLayout(l.name, l, copyCount);
                                }}
                              >
                                <Row>
                                  <Col style={{ display: "flex" }}>
                                    <FileCopyOutlinedIcon className="pop-list-icon" />
                                    <SystemLabel name="Copy" />
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                          <hr className="thin-hr-light" />
                          <Row>
                            <Col>
                              <div
                                className={"list-option"}
                                onClick={(e) => {
                                  /*     e.stopPropagation(); */
                                  deleteLayout(l);
                                }}
                              >
                                <Row>
                                  <Col style={{ display: "flex" }}>
                                    {deletedLayouts.find((dl) => dl.meetingLayoutId == l.meetingLayoutId) ? (
                                      <ReplayIcon className="pop-list-icon" />
                                    ) : (
                                      <DeleteOutlineOutlinedIcon className="pop-list-icon" />
                                    )}
                                    {deletedLayouts.find((dl) => dl.meetingLayoutId == l.meetingLayoutId) ? <SystemLabel name="Restore" /> : <SystemLabel name="Delete" />}
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </HeaderPopover>
                    </div>
                    {l.mobile ? <MobileFriendlyIcon className="centered-text placeholder-icon" /> : <ViewCompactOutlinedIcon className="centered-text placeholder-icon" />}
                    <GridListTileBar className="layout-actionbar" title={<span className="title">{l.name}</span>} />
                  </GridListTile>
                );
              })}
          </GridList>
          {editableLayout ? <EditDialog layout={editableLayout} save={onEdit} toggle={() => setEditableLayout(null)} {...props} /> : null}
          {createDialog ? <CreateDialog eventId={eventId} create={createLayout} layouts={layouts} toggle={() => toggleCreateDialog(!createDialog)} /> : null}
        </div>
      </Slide>
    </div>
  );
}

const IsPresented = () => {
  return (
    <Tooltip title={<SystemLabel name="IsPresentedInDigitalArena" />}>
      <SlideshowIcon className="presented-layout" />
    </Tooltip>
  );
};

const cardItemText = (type) => {
  return (
    <div className={`card-item-text ${type.toLowerCase()}`}>
      <SystemLabel name={type} />
    </div>
  );
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return (
    <Slide
      direction="up"
      ref={ref}
      {...props}
      timeout={{
        appear: 600,
        enter: 600,
        exit: 600,
      }}
    />
  );
});

const CreateDialog = ({ toggle, create, layouts, eventId }) => {
  const [copyFrom, setCopyFrom] = React.useState(null);
  const [copy, setCopy] = React.useState(false);
  const [name, setName] = React.useState("");
  const [mobile, setMobile] = React.useState(false);
  return (
    <Dialog className="dark-dialog" open={true} TransitionComponent={Transition} onClose={toggle}>
      <DialogContent style={{ width: 560 }} className="dark-l2 dark-input">
        <FormGroup>
          <Label className="primary-text">
            <SystemLabel name="LayoutName" />
          </Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </FormGroup>
        <FormGroup>
          <div className="btn-group" style={{ marginTop: 10, width: "50%" }}>
            <div
              className={"sq-btn" + (!copy ? " active" : "")}
              style={{ borderRadius: 10 }}
              onClick={() => {
                setCopy(false);
                setCopyFrom(null);
              }}
            >
              <InsertDriveFileOutlinedIcon className="primary-text" />
              <span>
                <SystemLabel name="NewLayout" />
              </span>
            </div>
            <div className={"sq-btn" + (copy ? " active" : "")} onClick={() => setCopy(true)} style={{ borderRadius: 10 }}>
              <FileCopyOutlinedIcon className="primary-text" />
              <span>
                <SystemLabel name="CopyLayout" />
              </span>
            </div>
          </div>
        </FormGroup>
        <br />
        <Row>
          <Col className="text-left">
            <Label className="primary-text">
              <SystemLabel name="MobileLayout" />
            </Label>
          </Col>
          <Col className="text-right">
            <JirangoSwitch onChange={() => setMobile(!mobile)} isChecked={mobile} />
          </Col>
        </Row>
        <br />
        {copy ? <CopiableLayouts copiableLayouts={layouts} selectedCopy={copyFrom} onCopy={setCopyFrom} eventId={eventId} mobile={mobile} /> : null}
      </DialogContent>
      <DialogActions className="dark-l2 ">
        <Button onClick={toggle} style={{ color: "#eee" }}>
          <SystemLabel name="Cancel" />
        </Button>
        <Button
          disabled={name.length < 1}
          onClick={() => {
            create(name, copyFrom, 1, mobile);
            setCopyFrom(null);
            toggle();
          }}
          style={{ color: "#eee" }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CopiableLayouts = ({ copiableLayouts, onCopy, mainEventId, selectedCopy, eventId, mobile }) => {
  const inheritedLayouts = copiableLayouts.filter((il) => il.eventId != (mainEventId || eventId));
  const currentEventLayouts = copiableLayouts.filter((il) => il.eventId == eventId);
  const mainEventLayouts = copiableLayouts.filter((il) => il.eventId != eventId);
  const isMainEvent = mainEventId == undefined;
  return (
    <FormGroup style={{ marginTop: 10 }}>
      {/*     <Label className="primary-text">
        <SystemLabel name="SelectALayoutToCopy" />
      </Label>
 */}
      {currentEventLayouts.length > 0 ? (
        <div>
          <FormGroup style={{ marginTop: 10 }}>
            <Label className="primary-text">
              <SystemLabel name="FromCurrentEvent" />
            </Label>
            <div className="copiable-layouts">
              {copiableLayouts
                .filter((l) => l.eventId == eventId)
                .map((cl, i) => {
                  return (
                    <div onClick={() => onCopy(cl)} style={{ position: "relative" }} className={"layout-list" + (selectedCopy && selectedCopy.meetingLayoutId == cl.meetingLayoutId ? " sel" : "")}>
                      {/*      {selectedCopy &&
                      selectedCopy.meetingLayoutId == cl.meetingLayoutId ? (
                        <DoneIcon className="primary-text" />
                      ) : null} */}
                      {cl.name}
                    </div>
                  );
                })}
            </div>
          </FormGroup>
        </div>
      ) : null}
      {!isMainEvent ? (
        <div>
          <FormGroup style={{ marginTop: 10 }}>
            <Label className="primary-text">
              <SystemLabel name="MainEventLayouts" />
            </Label>
            <div className="copiable-layouts">
              {copiableLayouts
                .filter((l) => l.eventId == mainEventId && l.mobile == mobile)
                .map((cl, i) => {
                  return (
                    <div onClick={() => onCopy(cl)} style={{ position: "relative" }} className={"layout-list" + (selectedCopy && selectedCopy.meetingLayoutId == cl.meetingLayoutId ? " sel" : "")}>
                      {cl.name}
                    </div>
                  );
                })}
            </div>
          </FormGroup>
        </div>
      ) : null}
      {inheritedLayouts.length > 0 ? (
        <div>
          <FormGroup style={{ marginTop: 10 }}>
            <Label className="primary-text">
              <SystemLabel name="InheritedLayouts" />
            </Label>
            <div className="copiable-layouts">
              {inheritedLayouts.map((cl, i) => {
                return (
                  <div onClick={() => onCopy(cl)} style={{ position: "relative" }} className={"layout-list" + (selectedCopy && selectedCopy.meetingLayoutId == cl.meetingLayoutId ? " sel" : "")}>
                    {/*    {selectedCopy &&
                    selectedCopy.meetingLayoutId == cl.meetingLayoutId ? (
                      <DoneIcon
                        style={{ margin: 10 }}
                        className="primary-text"
                      />
                    ) : null} */}
                    {cl.name}
                  </div>
                );
              })}
            </div>
          </FormGroup>
        </div>
      ) : null}
    </FormGroup>
  );
};

const EditDialog = ({ layout, toggle, save }) => {
  const [editedLayout, setEditedLayout] = React.useState(null);

  return (
    <Dialog className="dark-dialog" open={true} TransitionComponent={Transition} onClose={toggle}>
      <DialogContent style={{ width: 560 }} className="dark-l2 dark-input">
        <FormGroup>
          <Label className="primary-text">
            <SystemLabel name="LayoutName" />
          </Label>
          <Input value={editedLayout ? editedLayout.name : layout.name} onChange={(e) => setEditedLayout({ ...layout, name: e.target.value })} />
        </FormGroup>
      </DialogContent>
      <DialogActions className="dark-l2 ">
        <Button onClick={toggle} style={{ color: "#eee" }}>
          <SystemLabel name="Cancel" />
        </Button>
        <Button
          disabled={!editedLayout || editedLayout.name.length < 1}
          onClick={() => {
            save(editedLayout);
            toggle();
          }}
          style={{ color: "#eee" }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
